var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81,58.5 L61.5,58.5 L61.5,30 C61.5,29.1715729 60.8284271,28.5 60,28.5 C59.1715729,28.5 58.5,29.1715729 58.5,30 L58.5,60 C58.5,60.8284271 59.1715729,61.5 60,61.5 L81,61.5 C81.8284271,61.5 82.5,60.8284271 82.5,60 C82.5,59.1715729 81.8284271,58.5 81,58.5 Z M60,13.5 C34.3187591,13.5 13.5,34.3187591 13.5,60 C13.5,85.6812409 34.3187591,106.5 60,106.5 C85.6812409,106.5 106.5,85.6812409 106.5,60 C106.472442,34.3301825 85.6698175,13.5275575 60,13.5 L60,13.5 Z M60,103.5 C35.9756134,103.5 16.5,84.0243866 16.5,60 C16.5,35.9756134 35.9756134,16.5 60,16.5 C84.0243866,16.5 103.5,35.9756134 103.5,60 C103.472446,84.0129643 84.0129643,103.472446 60,103.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.3e261536.svg";
export { ForwardRef as ReactComponent };